import {schema} from 'normalizr'

const barcode_set = new schema.Entity('barcode_set_dict',{},{idAttribute:'name'})
const barcode_sets_schema = [barcode_set]
export default barcode_sets_schema